@let isInGroup = data.groupIndex !== null;
@if (store.isEditPanel()) {
	<sim-assessable-item
		[isInArchive]="isInArchive"
		[dragHandleTemplate]="data.dragHandle"
		[item]="data.item"
		[inEditMode]="isItemInEditMode()"
		[expanded]="isItemExpanded()"
		[mode]="AssessablePanelMode.Edit"
		[indexInGroup]="data.index"
		[groupIndex]="data.groupIndex"
		[canEnterEditMode]="contextService.form.valid"
		[disabled]="store.isDisabled()"
		[answerBadgeTemplate]="answerBadgeTemplate"
		[menuContentTemplate]="menuContentTemplate"
		[multipleChoiceItemTemplate]="multipleChoiceItemTemplate"
		[singleChoiceItemTemplate]="singleChoiceItemTemplate"
		[yesNoItemTemplate]="yesNoItemTemplate"
		[ratingItemTemplate]="ratingItemTemplate"
		[freeAnswerItemTemplate]="freeAnswerItemTemplate"
		(onExpand)="store.handleItemExpand(data.item.assessableItemId)"
		(onCollapse)="store.handleItemCollapse()"
		(onTimestampClicked)="onTimestampClicked.emit()"
		(onChangeChecklistItemType)="contextService.handleItemTypeChange(data.item, $event)"
		[scenarioRecording]="contextService.scenarioRecording"
	/>
} @else {
	<sim-assessable-answer-item
		[isInArchive]="isInArchive"
		[compactLayout]="compactLayout"
		[item]="data.item"
		[expanded]="isItemExpanded()"
		[mode]="store.mode()"
		[indexInGroup]="data.index"
		[groupIndex]="data.groupIndex"
		[disabled]="store.isDisabled()"
		[multipleChoiceItemTemplate]="multipleChoiceItemTemplate"
		[singleChoiceItemTemplate]="singleChoiceItemTemplate"
		[yesNoItemTemplate]="yesNoItemTemplate"
		[ratingItemTemplate]="ratingItemTemplate"
		[freeAnswerItemTemplate]="freeAnswerItemTemplate"
		(onExpand)="store.handleItemExpand(data.item.assessableItemId)"
		(onCollapse)="store.handleItemCollapse()"
		(onTimestampClicked)="onTimestampClicked.emit()"
		[scenarioRecording]="contextService.scenarioRecording"
	/>
}

<ng-template #answerBadgeTemplate>
	<mat-divider [vertical]="true" *ngIf="store.isEditPanel()" />

	<ng-container *ngVar="answerItemControl.value.answer !== null && answerItemControl.value.answer !== undefined as answered">
		<ng-container *ngIf="!store.isEditPanel() && answered">
			<button
				mat-icon-button
				[matTooltip]="T.SHARED_EXPANSION_CHECKLIST_ITEM_DONE | translate"
				[matTooltipClass]="'accent'"
				color="accent"
				appStopPropagation
				[@zoomInOnEnter]
			>
				<mat-icon style="font-size: 2em" inline fontSet="fad" fontIcon="fa-badge-check" />
			</button>
		</ng-container>

		<mat-divider style="margin-left: 10px" [vertical]="true" *ngIf="store.isAnswerPanel() && answered" />
	</ng-container>
</ng-template>

<ng-template #menuContentTemplate>
	<button
		mat-menu-item
		class="menueButtonWithFAIcon accent"
		(click)="
			isInGroup
				? contextService.shiftGroupedItem('up', data.groupIndex, data.index)
				: contextService.shiftUngroupedItem('up', data.index)
		"
		matTooltip="{{ T.SHARED_EXPANSION_MOVEUP_CHECKLIST | translate }}"
		matTooltipClass="accent"
		[disabled]="data.index === 0 || !contextService.form.valid"
	>
		<mat-icon class="smaller" fontSet="fad" fontIcon="fa-arrow-up" inline />
		<span>{{ T.SHARED_EXPANSION_MOVEUP_CHECKLIST | translate }}</span>
	</button>

	<button
		mat-menu-item
		class="menueButtonWithFAIcon accent"
		(click)="
			isInGroup
				? contextService.shiftGroupedItem('down', data.groupIndex, data.index)
				: contextService.shiftUngroupedItem('down', data.index)
		"
		matTooltip="{{ T.SHARED_EXPANSION_MOVEDOWN_CHECKLIST | translate }}"
		matTooltipClass="accent"
		[disabled]="data.index === data.length - 1 || !contextService.form.valid"
	>
		<mat-icon class="smaller" fontSet="fad" fontIcon="fa-arrow-down" inline />
		<span>{{ T.SHARED_EXPANSION_MOVEDOWN_CHECKLIST | translate }}</span>
	</button>

	<button
		*ngIf="!isInGroup && data.length > 0"
		mat-menu-item
		class="menueButtonWithFAIcon accent"
		[disabled]="!contextService.form.valid"
		(click)="contextService.moveItemToOtherGroup(data.index, data.groupIndex)"
		matTooltip="{{ T.SHARED_EXPANSION_MOVE_TO_GROUP | translate }}"
		matTooltipClass="accent"
	>
		<mat-icon class="smaller" fontSet="fad" fontIcon="fa-layer-plus" inline />
		<span>{{ T.SHARED_EXPANSION_MOVE_TO_GROUP | translate }}</span>
	</button>

	<button
		*ngIf="isInGroup"
		mat-menu-item
		class="menueButtonWithFAIcon accent"
		[disabled]="!contextService.form.valid"
		(click)="contextService.moveItemToOtherGroup(data.index, data.groupIndex)"
		matTooltip="{{ T.SHARED_EXPANSION_MOVE_TO_ANOTHER_GROUP | translate }}"
		matTooltipClass="accent"
	>
		<mat-icon class="smaller" fontSet="fad" fontIcon="fa-layer-minus" inline />
		<span>{{ T.SHARED_EXPANSION_MOVE_TO_ANOTHER_GROUP | translate }}</span>
	</button>

	<button
		*ngIf="isInGroup"
		mat-menu-item
		class="menueButtonWithFAIcon accent"
		[disabled]="!contextService.form.valid"
		(click)="contextService.moveGroupedItemToUngroupedItems(data.groupIndex, data.index)"
		matTooltip="{{ T.SHARED_EXPANSION_MOVE_NON_GROUPED | translate }}"
		matTooltipClass="accent"
	>
		<mat-icon class="smaller" fontSet="fad" fontIcon="fa-layer-minus" inline />
		<span>{{ T.SHARED_EXPANSION_MOVE_NON_GROUPED | translate }}</span>
	</button>

	<button
		mat-menu-item
		class="menueButtonWithFAIcon warn"
		[disabled]="!contextService.form.valid && !isItemInEditMode()"
		(click)="contextService.removeItem(createRemoveItemEvent(data.index, data.groupIndex))"
	>
		<mat-icon class="smaller" fontSet="fad" fontIcon="fa-trash-alt" inline />
		<span>{{ T.SHARED_EXPANSION_REMOVE_CHECKLIST | translate }}</span>
	</button>
</ng-template>

<ng-template #multipleChoiceItemTemplate>
	<sim-multiple-choice-item
		[mode]="store.mode()"
		[inEditMode]="isItemInEditMode()"
		[item]="mapToMultipleChoiceItem(data.item)"
		[optionTemplate]="optionTemplate"
		(onAddOption)="contextService.addSelectableOption(itemControl)"
		(onRemoveOption)="contextService.removeSelectableOption(itemControl, $event)"
		(onUpdateAnswerMultipleChoice)="handleMultipleChoiceAnswerChanged($event)"
	>
		<ng-template #optionTemplate let-context>
			<mat-form-field color="accent" class="full-width-form">
				<mat-label>{{ T.SHARED_EXPANSION_OPTION_TEXT | translate }}</mat-label>
				<sim-rich-text-editor-control [formControl]="itemControl.controls.selectableOptions.at(context.i)" />
				<mat-error *ngIf="itemControl.controls.selectableOptions.at(context.i).hasError('required')">{{
					T.SHARED_EXPANSION_OPTION_REQUIRED | translate
				}}</mat-error>
			</mat-form-field>
		</ng-template>
	</sim-multiple-choice-item>
</ng-template>

<ng-template #singleChoiceItemTemplate>
	<sim-single-choice-item
		[item]="mapToMultipleChoiceItem(data.item)"
		[mode]="store.mode()"
		[inEditMode]="isItemInEditMode()"
		[optionTemplate]="optionTemplate"
		(onAddOption)="contextService.addSelectableOption(itemControl)"
		(onRemoveOption)="contextService.removeSelectableOption(itemControl, $event)"
		(onUpdateAnswerSimple)="handleAnswerChanged($event)"
	>
		<ng-template #optionTemplate let-context>
			<mat-form-field color="accent" class="full-width-form">
				<mat-label>{{ T.SHARED_EXPANSION_OPTION_TEXT | translate }}</mat-label>
				<sim-rich-text-editor-control [formControl]="itemControl.controls.selectableOptions.at(context.i)" />
				<mat-error *ngIf="itemControl.controls.selectableOptions.at(context.i).hasError('required')">{{
					T.SHARED_EXPANSION_OPTION_REQUIRED | translate
				}}</mat-error>
			</mat-form-field>
		</ng-template>
	</sim-single-choice-item>
</ng-template>

<ng-template #yesNoItemTemplate>
	<sim-yes-no-item
		[answer]="answerItemControl.value.answer"
		[mode]="store.mode()"
		[disabled]="store.isDisabled()"
		(onUpdateAnswerSimple)="handleAnswerChanged($event)"
	/>
</ng-template>

<ng-template #ratingItemTemplate>
	<sim-rating-item
		[answer]="answerItemControl.value.answer"
		[mode]="store.mode()"
		[inEditMode]="isItemInEditMode()"
		[hideScore]="true"
		[stars]="data.item.maxStars"
		(onAddStar)="contextService.addThreeStarOption(itemControl)"
		(onRemoveStar)="contextService.removeThreeStarOption(itemControl)"
		(onStarClick)="handleAnswerChanged($event)"
	/>
</ng-template>

<ng-template #freeAnswerItemTemplate>
	<sim-free-answer-item
		[disabled]="store.isDisabled()"
		[hideScore]="true"
		[mode]="store.mode()"
		[answer]="answerItemControl.value.answer"
		(onFreeTextAnswerChanged)="handleAnswerChanged($event)"
	/>
</ng-template>
